export default __webpack_public_path__ + "static/media/loading.3fb26d9b.gif";